export default __webpack_public_path__ + "static/media/ashish.4e5458e8.png";